angular.module('shared')
  .factory 'SubscriptionPlanLimitService', (MessageService) ->
    validate: (data) ->
      if data.subscription_limit_exceeded
        MessageService.message(
          title: 'Subscription plan limit reached'
          message: data.message.split('<br />')
          confirmButtonText: 'Ok'
        )
